// extracted by mini-css-extract-plugin
export default {"fullBackground":"NotFound_fullBackground__SLe2L"};